import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "hex"]

  syncColor() {
    this.hexTarget.value = this.pickerTarget.value
  }

  syncHex() {
    if (/^#[0-9a-fA-F]{6}$/.test(this.hexTarget.value)) {
      this.pickerTarget.value = this.hexTarget.value
    }
  }
}
